import { ISSB_MAJOR_CODE, type Standard } from '@netpurpose/types'
import { type ReportingStandard, ReportingStandardClasses } from '../../generated/facts'

export type BackendStandard = ReportingStandard

export const parseStandard = (standard: BackendStandard): Standard => ({
  id: standard.reporting_standard_id,
  standardClass: standard.standard_class,
  majorCode:
    standard.standard_class === ReportingStandardClasses.ISSB
      ? ISSB_MAJOR_CODE
      : standard.major_code || undefined,
  fullCode: standard.full_code || undefined,
  description: standard.description || undefined,
  link: standard.link || undefined,
  colour: standard.colour || undefined,
})
